import {QtyWithPreview} from "./QtyWithPreview";
import {RouteStopGroup} from "../../../api/Logistics";
import {Completed} from "./Completed";
import {AuditLogIconPopper} from "./AuditLogIconPopper";

export function DropPoItemRow(props: {
    value: RouteStopGroup;
    routeCompleted: boolean;
}) {

    return (
        <tr>
            <td>PO #{props.value.dropoffPoNumber}</td>
            <td>
                <div style={{display: "flex", alignItems: "center", justifyContent: "flex-end"}}>
                    <QtyWithPreview data={props.value.items || []}/>
                    <AuditLogIconPopper group={props.value.id}/>
                </div>
            </td>
            <td>
                <Completed contents={props.value.items || []} routeComplete={props.routeCompleted} complete={props.value.completed} />
            </td>
            <td></td>
        </tr>
    )
}